import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { FormikProvider, useFormik } from 'formik';
import React, { useEffect } from 'react';
import { TransportadoraAction } from '../../store/transportadoraAction';
import { useTransportadora } from '../../store/transportadoraContext';
import TransportadoraBuscaAvancadaForm from './TransportadoraBuscaAvancadaForm';

const TransportadoraBuscaAvancadaModal = () => {
  const [state, dispatch] = useTransportadora();
  const { buscaAvancada, filtroAvancado, requestParams } = state;

  const handleCancelar = () => {
    TransportadoraAction.fecharModal(dispatch, formik.dirty);
  };

  const handleSubmit = (values) => {
    TransportadoraAction.setFiltroAvancado(dispatch, values);
    TransportadoraAction.fecharModal(dispatch);
    TransportadoraAction.buscarRegistros(dispatch,{size: requestParams.size, sort: requestParams.sort}, values, );
  };

  const formik = useFormik({
    initialValues: filtroAvancado,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (buscaAvancada) {
      formik.resetForm(filtroAvancado);
    }
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buscaAvancada]);

  return (
    <SimpleDialog open={buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<TransportadoraBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default TransportadoraBuscaAvancadaModal;
